import { render, staticRenderFns } from "./return_price.vue?vue&type=template&id=4730e2dd&scoped=true"
import script from "./return_price.vue?vue&type=script&lang=js"
export * from "./return_price.vue?vue&type=script&lang=js"
import style0 from "./return_price.vue?vue&type=style&index=0&id=4730e2dd&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4730e2dd",
  null
  
)

export default component.exports